import * as React from "react";
import Treatment from "../model/treatment/Treatment";
import { sanitize } from "../utils/sanitize";

interface TreatmentViewerProps {
  treatment: Treatment;
}

export default function TreatmentViewer({ treatment }: TreatmentViewerProps) {
  let layoutClass: string;
  if (treatment.description && treatment.imageUrl) {
    layoutClass = "text-and-picture-layout";
  } else if (treatment.description) {
    layoutClass = "text-layout";
  } else if (treatment.imageUrl) {
    layoutClass = "picture-layout";
  }

  return (
    <div key={treatment.uid} className="treatment-option">
      <div className="name">{treatment.name}</div>
      <div className={layoutClass}>
        {treatment.imageUrl && (
          <div className="picture">
            <img src={treatment.imageUrl} alt={"treatment-img"} />
          </div>
        )}
        {treatment.description && (
          <div className="text">
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(treatment.description),
              }}
            />
          </div>
        )}
        {layoutClass === "text-and-picture-layout" && <div style={{ clear: "both" }} />}
      </div>
    </div>
  );
}
